import { render } from "./NewClient.vue?vue&type=template&id=0dee32e8&scoped=true"
import script from "./NewClient.vue?vue&type=script&lang=js"
export * from "./NewClient.vue?vue&type=script&lang=js"

import "./NewClient.vue?vue&type=style&index=0&id=0dee32e8&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dee32e8"]])

export default __exports__